var App = App || {};

App.CmpMultiMedia = (function () {
    'use strict';


    const click = (button) => {
        const player = button.closest(".cmp--multiMedia__video");
        play(player);
    };

    const play = (player) => {
        // stop all other videos before starting a new one
        const videoEls = document.querySelectorAll(".cmp--multiMedia__video");
        videoEls.forEach(videoEl => { stop(videoEl); });

        // update the video from button to iframe
        const iframe = player.querySelector(".cmp--multiMedia__iframe");
        const playBtn = player.querySelector(".cmp--multiMedia__play");
        const source = playBtn.getAttribute("data-src");
        const title = playBtn.getAttribute("data-title");

        switch (true) {
            case source.toLowerCase().indexOf("youtube") >= 0:
                iframe.innerHTML = getYoutubeIframe(source, title);
                break;
            case source.toLowerCase().indexOf("vimeo") >= 0:
                iframe.innerHTML = getVimeoIframe(source, title);
                break;
            default:
                console.log("Could not locate video content");
        }

        playBtn.style.display = "none";
        iframe.style.display = "block";

        // if the video is in a modal add to the close event
        const modal = player.closest(".modal");
        if (modal) {
            modal.addEventListener("hidden.bs.modal", function () {
                stop(player);
            });
        }
    };

    const stop = (player) => {
        const iframe = player.querySelector(".cmp--multiMedia__iframe");
        const playBtn = player.querySelector(".cmp--multiMedia__play");

        iframe.style.display = "none";
        iframe.innerHTML = "";
        playBtn.style.display = "block";
    };

    const getYoutubeIframe = (source, title) => {
        return `<iframe src="${source}" title="${title}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
    };

    const getVimeoIframe = (source, title) => {
        return `<iframe src="${source}" title="${title}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
    };

    const transcriptAlignment = (carouselEl) => {
        const transcripts = [...carouselEl.querySelectorAll(".cmp--multiMedia__transcript")];
        if (!transcripts.length) return;

        transcripts.forEach(el => el.style.height = "");
        const maxHeight = Math.max(...transcripts.map(el => el.offsetHeight));
        transcripts.forEach(el => el.style.height = `${maxHeight}px`);
    };

    return {
        click,
        play,
        stop,
        transcriptAlignment
    };

})();
